export enum AddBookCodeFields {
    BookCode = 'bookCode'
}

export type AddBookCodeShape = {
    [AddBookCodeFields.BookCode]: string
}
